<div ngModelGroup="comboEixo-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboEixo
                       nome="eixo-{{data}}"
                       [itens]="dados"
                       itemDescricao="nome"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome do eixo"
                       label="Eixo:"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
